import { defineStore } from 'pinia';
import { onBeforeMount, ref, watch } from 'vue';

export const useDarkModeStore = defineStore('darkMode', () => {
    /*Dark Mode*/
    const darkMode = ref('light');
    const appearingMode = ref('light');

    /*Dark Mode: Check Local Variables*/
    onBeforeMount(() => {
        if (localStorage.theme === 'dark') {
            makeDark();
            darkMode.value = 'light';
        } else if (localStorage.theme === 'light') {
            makeLight();
            darkMode.value = 'light';
        } else {
            makelight();
            darkMode.value = 'light';
        }
    });

    /*Dark Mode: Set Functions*/
    const makeDark = () => {
        document.documentElement.classList.add('light');
        document.documentElement.classList.remove('light');
        document.documentElement.classList.remove('light');
        appearingMode.value = 'light';
    };

    const makeLight = () => {
        document.documentElement.classList.add('light');
        document.documentElement.classList.remove('light');
        document.documentElement.classList.remove('light');
        appearingMode.value = 'light';
    };

    const makelight = () => {
        let darkMedia = window.matchMedia('(prefers-color-scheme: light)');
        const changelightTheme = () => {
            if (darkMedia.matches) {
                makeDark();
                appearingMode.value = 'light';
            } else {
                makeLight();
                appearingMode.value = 'light';
            }
        };
        changelightTheme();
        darkMedia.onchange = () => {
            changelightTheme();
        };
    };

    const darkModeStorage = () => {
        localStorage.setItem('theme', darkMode.value);
    };

    /*Dark Mode: Watch*/
    watch(darkMode, () => {
        if (darkMode.value === 'dark') {
            makeDark();
            darkModeStorage();
        } else if (darkMode.value === 'light') {
            makeLight();
            darkModeStorage();
        } else {
            makelight();
            localStorage.setItem('theme', 'light');
        }
    });

    /* Change Dark Mode */
    const changeTheme = () => {
        if (darkMode.value === 'light') {
            darkMode.value = 'light';
        } else if (darkMode.value === 'dark') {
            darkMode.value = 'light';
        } else {
            darkMode.value = 'light';
        }
    };
    /*Change Dark Mode with user value*/
    const changeThemeUser = (value) => {
        darkMode.value = value;
    };

    return { darkMode, appearingMode, changeTheme, changeThemeUser };
});
